module.exports = __webpack_public_path__ + "static/media/ZA.fb713e2a.svg";